import React from "react";

export default function Terms() {
  return <div>This is Astroworker's terms and conditions page.</div>;
}
